import ChannelsService from 'data/ChannelsService';
import Http from 'components/http/Http';


const _BATCH_SIZE = 50;
const _THROTTLE_MILLIS = 2000;
const _SYNC_PATH = '/api/add';


class Syncer {
  constructor() {
    this.channelsService = new ChannelsService.Factory().create();
    this.http = new Http.Factory().create();
    this.intervalId = null;
    this.isRequestPending = false;
    this.safeMap = {}; // Map from channelId => timestamp confirmed by server.
  }

  startSync() {
    if (!this.intervalId) {
      this.intervalId = setInterval(this.trySync.bind(this), _THROTTLE_MILLIS);
    }
  }

  stopSync() {
    clearInterval(this.intervalId);
    this.intervalId = null;
  }

  async trySync() {
    const maxT = c => c.getData()[c.getData().length - 1].t.getTime();
    const syncedT = c => (this.safeMap[c.getId()] || 0);
    const channelsToSync = Object.values(this.channelsService.getChannelList())
        .map(c => c.channel)
        .filter(c => c && c.getData().length)
        .filter(c => maxT(c) !== syncedT(c))
        .sort((c1, c2) => syncedT(c1) - syncedT(c2));
    if (!channelsToSync.length) {
      return;
    }
    const channel = channelsToSync[0];
    const synced = syncedT(channel);
    const dataPoints = channel.getData()
        .filter(d => d.t.getTime() > synced)
        .slice(0, _BATCH_SIZE);
    const newSafeT = dataPoints[dataPoints.length - 1].t.getTime();

    const data = {
      channel_data: {
        name: channel.getId(),
        metadata: {
          units: channel.getUnits(),
        },
        data: dataPoints,
      },
    };

    try {
      await this.http.post(_SYNC_PATH).send(data);
    } catch(error) {
      console.log(error.status);
      console.log(error);
      return;
    }

    this.safeMap[channel.getId()] = newSafeT;
  }

  getSyncedTimeMillis(channelId) {
    return this.safeMap[channelId];
  }
}


Syncer.Factory = class {
  create() {
    return _instance;
  }
}


const _instance = new Syncer();


export default Syncer;
